import { Injectable } from '@angular/core';
import { refTypeInitialState, RefTypeStateProps, refTypeStateStore } from './ref-type-state.store';
import { BaseStoreRepository } from '../base-store.repository';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class RefTypeRepository extends BaseStoreRepository<RefTypeStateProps> {
  constructor() {
    super(refTypeStateStore.pipe(select(state => state)), refTypeStateStore, refTypeInitialState);
  }
}
